// ERP menu items
import {
  ApartmentOutlined,
  BuildOutlined,
  ClusterOutlined,
  DatabaseOutlined,
  HomeOutlined,
  OrderedListOutlined,
  SafetyOutlined,
  SwapOutlined,
  TeamOutlined,
  ToolOutlined
} from '@ant-design/icons';

// icons
const icons = {
  ApartmentOutlined,
  BuildOutlined,
  ClusterOutlined,
  DatabaseOutlined,
  HomeOutlined,
  OrderedListOutlined,
  SafetyOutlined,
  SwapOutlined,
  TeamOutlined,
  ToolOutlined
};

// ==============================|| MENU ITEMS - ERP ||============================== //

const erp = {
  id: 'erp',
  title: 'Termoplast ERP',
  type: 'group',
  children: [
    {
      id: 'erp-quick-start',
      title: 'Dashboard',
      type: 'item',
      url: '/erp/quick-start',
      icon: icons.ClusterOutlined,
      roles: ['manager', 'planner', 'operator']
    },
    {
      id: 'erp-customer-orders',
      title: 'Müşteri Siparişleri',
      type: 'item',
      url: '/erp/customer-orders',
      icon: icons.OrderedListOutlined,
      roles: ['manager', 'planner']
    },
    {
      id: 'erp-customer-orders-import',
      title: 'Sipariş Import',
      type: 'item',
      url: '/erp/customer-orders/import',
      icon: icons.OrderedListOutlined,
      roles: ['manager', 'planner']
    },
    {
      id: 'erp-work-orders',
      title: 'İş Emirleri',
      type: 'item',
      url: '/erp/work-orders',
      icon: icons.SafetyOutlined,
      roles: ['manager', 'planner']
    },
    {
      id: 'erp-shop-floor',
      title: 'Üretim Takibi',
      type: 'item',
      url: '/erp/shop-floor',
      icon: icons.BuildOutlined,
      roles: ['manager', 'planner', 'operator']
    },
    {
      id: 'erp-parts-board',
      title: 'Parça Panosu',
      type: 'item',
      url: '/erp/production/parts-board',
      icon: icons.ClusterOutlined,
      roles: ['manager', 'planner', 'operator']
    },
    {
      id: 'erp-aircraft-progress',
      title: 'Uçak İlerleme',
      type: 'item',
      url: '/erp/production/aircraft-progress',
      icon: icons.ClusterOutlined,
      roles: ['manager', 'planner', 'operator']
    },
    {
      id: 'erp-purchasing',
      title: 'Satın Alma',
      type: 'item',
      url: '/erp/purchasing',
      icon: icons.OrderedListOutlined,
      roles: ['manager', 'planner']
    },
    {
      id: 'erp-stock',
      title: 'Stok / Sevk',
      type: 'collapse',
      icon: icons.DatabaseOutlined,
      roles: ['manager', 'planner'],
      children: [
        {
          id: 'erp-status-board',
          title: 'Durum Panosu',
          type: 'item',
          url: '/erp/status-board',
          icon: icons.SafetyOutlined,
          roles: ['manager', 'planner']
        },
        {
          id: 'erp-inventory-moves',
          title: 'Stok / Sevk',
          type: 'item',
          url: '/erp/inventory-moves',
          icon: icons.SwapOutlined,
          roles: ['manager', 'planner']
        }
      ]
    },
    {
      id: 'erp-management',
      title: 'Tanımlar',
      type: 'collapse',
      icon: icons.ApartmentOutlined,
      roles: ['manager'],
      children: [
        {
          id: 'erp-users',
          title: 'Kullanıcı Yönetimi',
          type: 'item',
          url: '/erp/users',
          icon: icons.TeamOutlined,
          roles: ['manager']
        },
        {
          id: 'erp-items-list',
          title: 'Ürünler',
          type: 'item',
          url: '/erp/items',
          roles: ['manager']
        },
        {
          id: 'erp-item-categories',
          title: 'Ürün Kategorileri',
          type: 'item',
          url: '/erp/item-categories',
          roles: ['manager']
        },
        {
          id: 'erp-routings',
          title: 'Rotalar',
          type: 'item',
          url: '/erp/routings',
          roles: ['manager']
        },
        {
          id: 'erp-operations',
          title: 'Operasyonlar',
          type: 'item',
          url: '/erp/operations',
          icon: icons.ToolOutlined,
          roles: ['manager']
        },
        {
          id: 'erp-workcenters',
          title: 'İş İstasyonları',
          type: 'item',
          url: '/erp/workcenters',
          icon: icons.ApartmentOutlined,
          roles: ['manager']
        },
        {
          id: 'erp-warehouses',
          title: 'Depolar',
          type: 'item',
          url: '/erp/warehouses',
          icon: icons.HomeOutlined,
          roles: ['manager']
        }
      ]
    }
  ]
};

export default erp;
